// eslint-disable-next-line import/no-extraneous-dependencies -- it is already available due to redux-session library
import jwtDecode from 'jwt-decode';

import { GlobalAppState } from 'rdx/state';
import { consoleError } from 'utils/consoleError';

export const selectSessionAccessTokenState = (state: GlobalAppState) => {
  return state.session.accessToken;
};

export const selectSessionRefreshTokenState = (state: GlobalAppState) => {
  return state.session.refreshToken;
};

export const selectLogoutRequestState = (state: GlobalAppState) => {
  return state.authRequest.logoutRequestState;
};

export const selectAccountId = (state: GlobalAppState) => {
  try {
    const { accessToken } = state.session;
    const accountInfo = jwtDecode(accessToken) as undefined | { data?: { account_id: number } };
    return accountInfo?.data?.account_id;
  } catch (e) {
    // TODO Shall we report it to bugsnag?
    consoleError(e);
  }
  return undefined;
};

export const selectAccountVendorPermissions = (state: GlobalAppState): number[] | undefined => {
  try {
    const { accessToken } = state.session;
    const accountInfo = jwtDecode(accessToken) as
      | undefined
      | { data?: { vendor_permissions: { vendor_id: number }[] } };
    return accountInfo?.data?.vendor_permissions.map(
      (vendorPermission) => vendorPermission.vendor_id,
    );
  } catch (e) {
    // TODO Shall we report it to bugsnag?
    consoleError(e);
  }
  return undefined;
};
